import React, { useState, useEffect } from 'react';
import AuthUser from '../../../../../../pageauth/AuthUser';
import PuenteApi from '../../../../../../pageauth/PuenteApi';
import Mensaje from '../../../../../../Mensaje';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cargando from '../../../../../../Cargando';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import CryptoJS from "crypto-js";

export const RW_Config_Modulos_Agregar = () => {
    require('../../../Remotework.css?v=1.1.0');
    const navigate = useNavigate();
    const { SetMensaje } = Mensaje();
    const { StartCargando, StopCargando } = Cargando();
    const { ObtenerEstaciones, ObtenerModulosPorEndpoint, AgregarModulo, ObtenerRazonesSociales } = PuenteApi();
    const { getModule, getModuleSector, getApodoSector } = AuthUser();

    const [estaciones, setEstaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState({});
    const [modulosPorEstacion, setModulosPorEstacion] = useState({});
    const [showModal, setShowModal] = useState(false); // Para mostrar el modal
    const [formData, setFormData] = useState({
        estacion: '',
        tipoModulo: 'Shop',
        apodo: '',
        integracionPostnet: 'MercadoPago_automatico',
        items: [],
        posData: [], // Para la nueva tabla dinámica
        razon_social_id: '',
        membrete: {
            razon_social: '',
            domicilio: '',
            cuit: '',
            condicion: ''
        }
    });
    const [razones, setRazones] = useState([]);

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        const estacionesGuardadas = localStorage.getItem("estaciones");

        if (estacionesGuardadas) {
            const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
            const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            setEstaciones(parsed);
            obtenerModulosDeTodas(parsed);
        } else {
            obtenerEstaciones();
        }
    }, []);

    useEffect(() => {
        const fetchRazones = async () => {
            if (formData.estacion) {
                const estacionSeleccionada = estaciones.find(e => e.id == formData.estacion);
                if (estacionSeleccionada) {
                    const result = await ObtenerRazonesSociales(estacionSeleccionada.endpoint);
                    if (result) {
                        setRazones(result);
                    }
                }
            } else {
                setRazones([]);
            }
        };
        fetchRazones();
    }, [formData.estacion, estaciones]);

    const obtenerEstaciones = async () => {
        try {
            setLoading(true);
            const response = await ObtenerEstaciones();

            if (response) {
                setEstaciones(response);

                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());

                await obtenerModulosDeTodas(response);
            }
        } catch (error) {
            console.error("Error al obtener estaciones:", error);
        }
    };

    const obtenerModulosDeTodas = async (listaEstaciones) => {
        const resultados = {};

        for (const estacion of listaEstaciones) {
            try {
                const response2 = await ObtenerModulosPorEndpoint(estacion.endpoint);
                if (response2) {
                    const modulosFiltrados = response2.filter(modulo => modulo.nombre !== "Remotework");
                    if (modulosFiltrados.length > 0) {
                        resultados[estacion.id] = modulosFiltrados;
                    } else {
                        resultados[estacion.id] = [];
                    }
                } else {
                    resultados[estacion.id] = [];
                }
            } catch (error) {
                console.error("Error obteniendo módulos de", estacion.nombre, error);
                resultados[estacion.id] = [];
            }
        }
        setModulosPorEstacion(resultados);
        setLoading(false);
    };

    const handleToggle = (id) => {
        setExpanded(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const handleClose = () => {
        navigate('/Remotework/configuracion/modulos');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle membrete fields separately
        if (name.startsWith('membrete.')) {
            const field = name.split('.')[1];
            setFormData(prev => ({
                ...prev,
                membrete: {
                    ...prev.membrete,
                    [field]: value
                }
            }));
            return;
        }

        if (name === 'razon_social_select') {
            const selectedRazon = razones.find(r => r.id == value);
            if (selectedRazon) {
                setFormData(prev => ({
                    ...prev,
                    razon_social_id: value,
                    membrete: {
                        razon_social: selectedRazon.razon_social,
                        domicilio: selectedRazon.domicilio,
                        cuit: selectedRazon.cuit,
                        condicion: selectedRazon.condicion_iva
                    }
                }));
            } else {
                // If deselected or invalid
                setFormData(prev => ({
                    ...prev,
                    razon_social_id: value
                }));
            }
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }
    };

    // Para manejar el cambio de los campos en la tabla de items
    const handleItemsTableChange = (index, column, value) => {
        const newItemsData = [...formData.items];
        newItemsData[index] = { ...newItemsData[index], [column]: value };
        setFormData({ ...formData, items: newItemsData });
    };

    // Para manejar el cambio en la tabla dinámica de POS
    const handlePosTableChange = (index, column, value) => {
        const newPosData = [...formData.posData];
        newPosData[index] = { ...newPosData[index], [column]: value };
        setFormData({ ...formData, posData: newPosData });
    };


    // Función para agregar una nueva fila en la tabla de items
    const addItemRow = () => {
        setFormData((prevData) => ({
            ...prevData,
            items: [...prevData.items, { tipoCombustible: 'DIESEL', manguera: '', aforador: '', modo: 'Automatico', isla: '' }]
        }));
    };

    // Función para eliminar una fila de la tabla de items
    const removeItemRow = (index) => {
        const newItemsData = formData.items.filter((_, i) => i !== index);
        setFormData({ ...formData, items: newItemsData });
    };

    // Función para agregar una nueva fila en la tabla dinámica POS
    const addPosRow = () => {
        setFormData((prevData) => ({
            ...prevData,
            posData: [...prevData.posData, { numeroSerie: '' }]
        }));
    };

    // Función para eliminar una fila de la tabla dinámica POS
    const removePosRow = (index) => {
        const newPosData = formData.posData.filter((_, i) => i !== index);
        setFormData({ ...formData, posData: newPosData });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        StartCargando("Agregando modulo");
        const endpoint = estaciones.find(estacion => estacion.id == formData.estacion).endpoint;
        const resultado = await AgregarModulo(endpoint, formData);
        StopCargando();
        if (resultado) {
            await Swal.fire("Modulo agregado", "Modulo agregado correctamente", "success");
            navigate('/Remotework/configuracion/modulos');
        }
    };

    return (
        <>
            {loading ? (
                "Cargando..."
            ) : (
                <div className="container-fluid py-4" style={{ backgroundColor: 'white', borderRadius: '15px', padding: '20px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                    {/* Titulo del formulario */}
                    <h4>Agregar Nuevo Módulo</h4>

                    <Form onSubmit={handleSubmit} onKeyDown={(e) => {
                        // Prevenir el envío del formulario solo si la tecla presionada es Enter
                        if (e.key === 'Enter') {
                            e.preventDefault(); // Previene el envío del formulario
                        }
                    }}>
                        {/* Selector de estación */}
                        <Form.Group controlId="formEstacion">
                            <Form.Label>Estación</Form.Label>
                            <Form.Control as="select" name="estacion" value={formData.estacion} onChange={handleInputChange}>
                                <option value="">Seleccione una estación</option>
                                {estaciones.map((estacion) => (
                                    <option key={estacion.id} value={estacion.id}>
                                        {estacion.nombre}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>

                        {/* Selector de tipo de módulo */}
                        <Form.Group controlId="formTipoModulo">
                            <Form.Label>Tipo de Módulo</Form.Label>
                            <Form.Control as="select" name="tipoModulo" value={formData.tipoModulo} onChange={handleInputChange}>
                                <option value="Shop">Shop</option>
                                <option value="Playa">Playa</option>
                            </Form.Control>
                        </Form.Group>

                        {/* Apodo del módulo */}
                        <Form.Group controlId="formApodo">
                            <Form.Label>Apodo</Form.Label>
                            <Form.Control
                                type="text"
                                name="apodo"
                                value={formData.apodo}
                                onChange={handleInputChange}
                                placeholder="Ingrese el nombre o apodo"
                            />
                        </Form.Group>

                        {/* Campo de Integración Postnet */}
                        <Form.Group controlId="formIntegracionPostnet">
                            <Form.Label>Integración Postnet</Form.Label>
                            <Form.Control as="select" name="integracionPostnet" value={formData.integracionPostnet} onChange={handleInputChange}>
                                <option value="MercadoPago_automatico">Mercado Pago Manual</option>
                                <option value="MercadoPago_PDV">Mercado Pago Punto de venta</option>
                            </Form.Control>
                        </Form.Group>



                        {/* Tabla dinámica para número de serie y tipo POS */}
                        <Form.Label>Postnet asociados a este módulo</Form.Label>
                        <div className="d-flex align-items-center mb-3">
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Número de Serie</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.posData.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    value={item.numeroSerie}
                                                    onChange={(e) => handlePosTableChange(index, 'numeroSerie', e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <Button variant="danger" onClick={() => removePosRow(index)}>Eliminar</Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            {/* Botón "Agregar Fila" al lado de la tabla */}
                            <Button variant="primary" onClick={addPosRow} className="ml-3">
                                +
                            </Button>
                        </div>

                        {/* Mostrar la sección "Mangueras asociadas" solo si se selecciona "Playa" */}
                        {formData.tipoModulo === "Playa" && (
                            <>
                                <Form.Label>Mangueras asociadas a este módulo</Form.Label>
                                <div className="d-flex align-items-center mb-3">
                                    <Table striped bordered hover responsive className="flex-grow-1">
                                        <thead>
                                            <tr>
                                                <th>Tipo Combustible</th>
                                                <th>Manguera</th>
                                                <th>Aforador</th>
                                                <th>Modo</th>
                                                <th>Isla</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formData.items.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Form.Control
                                                            as="select"
                                                            value={item.tipoCombustible}
                                                            onChange={(e) => handleItemsTableChange(index, 'tipoCombustible', e.target.value)}
                                                        >
                                                            <option value="DIESEL">DIESEL</option>
                                                            <option value="GNC">GNC</option>
                                                            <option value="AIRE">AIRE</option>
                                                            <option value="COMPRESORGNC">COMPRESORGNC</option>
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            value={item.manguera}
                                                            onChange={(e) => handleItemsTableChange(index, 'manguera', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            value={item.aforador}
                                                            onChange={(e) => handleItemsTableChange(index, 'aforador', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            as="select"
                                                            value={item.modo}
                                                            onChange={(e) => handleItemsTableChange(index, 'modo', e.target.value)}
                                                        >
                                                            <option value="Automatico">Automático</option>
                                                            <option value="Manual">Manual</option>
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            value={item.isla}
                                                            onChange={(e) => handleItemsTableChange(index, 'isla', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Button variant="danger" onClick={() => removeItemRow(index)}>Eliminar</Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>

                                    {/* Botón "Agregar Fila" al lado de la tabla */}
                                    <Button variant="primary" onClick={addItemRow} className="ml-3">
                                        +
                                    </Button>
                                </div>
                            </>
                        )}

                        <Form.Group controlId="formRazonSocialSelect" className="mb-3">
                            <Form.Label>Asociar Razón Social</Form.Label>
                            <Form.Control
                                as="select"
                                name="razon_social_select"
                                value={formData.razon_social_id || ''}
                                onChange={handleInputChange}
                                required
                                disabled={!formData.estacion}
                            >
                                <option value="">Seleccione una Razón Social...</option>
                                {razones.map(razon => (
                                    <option key={razon.id} value={razon.id}>
                                        {razon.razon_social} ({razon.cuit})
                                    </option>
                                ))}
                            </Form.Control>
                            {!formData.estacion && <Form.Text className="text-muted">Seleccione una estación primero.</Form.Text>}
                            <Form.Text className="text-muted">
                                Seleccionar una razón social completará los campos de abajo, pero puede editarlos manualmente si es necesario.
                            </Form.Text>
                        </Form.Group>

                        {/* Membrete Configuration */}
                        <div className="card mb-3 p-3 bg-light">
                            <h5>Configuración de Membrete</h5>

                            <Form.Group controlId="formRazonSocial" className="mb-2">
                                <Form.Label>Razón Social (Texto Membrete)</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="membrete.razon_social"
                                    value={formData.membrete?.razon_social || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group controlId="formDomicilio" className="mb-2">
                                <Form.Label>Domicilio</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="membrete.domicilio"
                                    value={formData.membrete?.domicilio || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </Form.Group>

                            <div className="row">
                                <div className="col-md-6">
                                    <Form.Group controlId="formCuit" className="mb-2">
                                        <Form.Label>CUIT</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="membrete.cuit"
                                            value={formData.membrete?.cuit || ''}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group controlId="formCondicion" className="mb-2">
                                        <Form.Label>Condición IVA</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="membrete.condicion"
                                            value={formData.membrete?.condicion || ''}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end mt-3">
                            <Button variant="secondary" onClick={handleClose} style={{ marginRight: '10px' }}>
                                Volver
                            </Button>
                            <Button variant="success" type="submit">
                                Guardar Módulo
                            </Button>
                        </div>
                    </Form>
                </div>)}
        </>
    );

};
